<div class="w-100" [ngClass]="{'border rounded-1 p-2': hasBorder}">
    <iframe #iframe
        [hidden]="loading"
        class="w-100"
        style="transition: height .1s"
        scrolling="no"
        allow="clipboard-read; picture-in-picture; clipboard-write; accelerometer; autoplay; encrypted-media; web-share; gyroscope; fullscreen; geolocation"
        [attr.data-sb-qa]="qaTag"
        (load)="Load(iframe)">
    </iframe>
    @if (loading) {
        <ng-content select="[loading]"></ng-content>
    }
</div>
